import { useCallback } from 'react';
import { rage, useObservable } from '~/rage';
import { ModalButtonColor, ModalType, WalletType } from '~/shared';
import { useLayoutSelector } from '../redux';

const useBuy = () => {
	const activeItem = useLayoutSelector((state) => state.productShop.activeItem);
	const count = useLayoutSelector((state) => state.productShop.count);
	const modalState = useObservable(rage.modal.getCurrentModal());

	const handleBuy = useCallback(
		(walletType: WalletType) => {
			if (!activeItem || modalState) {
				return;
			}

			const paymentWallet =
				activeItem.walletType === WalletType.Donate
					? WalletType.Donate
					: walletType;
			const text = `Вы действительно хотите оплатить ${
				paymentWallet === WalletType.Donate
					? 'донат-валютой'
					: paymentWallet === WalletType.Cash
					? 'наличными'
					: 'картой'
			} товар "${activeItem.name}" ${count + 1} шт.?`;

			rage.modal.showModal(
				{
					type: ModalType.Price,
					title: 'Подтверждение',
					text: text,
					price: activeItem.price * (count + 1),
					wallet: paymentWallet,
					acceptButton: { text: 'Оплатить', color: ModalButtonColor.Success },
					cancelButton: {
						text: 'Отменить',
						color: ModalButtonColor.Secondary,
					},
				},
				(result) => {
					if (result.isAccepted) {
						rage.productShop.buy(activeItem.id, count + 1, paymentWallet);
					}
				},
			);
		},
		[activeItem, count, modalState],
	);

	return { handleBuy };
};

export { useBuy };
